import * as React from 'react'

export const StageText = props => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12634)">
      <path
        d="M33.0674 8.66097C34.8165 7.63532 36.9835 7.63532 38.7326 8.66097L60.8454 21.6273C62.5597 22.6325 63.6128 24.4708 63.6128 26.458V52.542C63.6128 54.5292 62.5597 56.3675 60.8454 57.3727L38.7326 70.339C36.9835 71.3647 34.8165 71.3647 33.0674 70.339L10.9546 57.3727C9.24032 56.3675 8.18718 54.5292 8.18718 52.542V26.458C8.18718 24.4708 9.24032 22.6325 10.9546 21.6273L33.0674 8.66097Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.0902 15.6192C34.8278 14.6112 36.9722 14.6112 38.7099 15.6192L55.4006 25.3009C57.1277 26.3027 58.1908 28.1483 58.1908 30.1449V49.554C58.1908 51.5506 57.1277 53.3962 55.4006 54.398L38.7099 64.0798C36.9722 65.0877 34.8278 65.0877 33.0902 64.0798L16.3994 54.398C14.6723 53.3962 13.6093 51.5506 13.6093 49.554V30.1449C13.6093 28.1483 14.6723 26.3027 16.3994 25.3009L33.0902 15.6192Z"
        fill="#507299"
      />
      <path
        d="M51.7012 49.934L40.7696 57.9213L43.751 49.934H51.7012Z"
        fill="#CEC198"
      />
      <path
        d="M45.7385 25.9708C49.0316 25.9708 51.7014 28.6534 51.7014 31.962V49.9337L40.7698 57.922V57.921L51.7014 49.9337H26.8567C23.5637 49.9337 20.894 47.252 20.8938 43.9435V31.962C20.8938 28.6534 23.5636 25.9708 26.8567 25.9708H45.7385Z"
        fill="#FFFAC7"
      />
      <path
        d="M36.7947 43.4431C36.7947 43.7192 36.5709 43.9431 36.2947 43.9431H25.369C25.0928 43.9431 24.869 43.7192 24.869 43.4431V42.446C24.869 42.1698 25.0928 41.946 25.369 41.946H36.2947C36.5709 41.946 36.7947 42.1698 36.7947 42.446V43.4431ZM40.7693 43.4431C40.7693 43.7192 40.5455 43.9431 40.2693 43.9431H39.282C39.0059 43.9431 38.782 43.7192 38.782 43.4431V42.446C38.782 42.1698 39.0059 41.946 39.282 41.946H40.2693C40.5455 41.946 40.7693 42.1698 40.7693 42.446V43.4431ZM27.8504 38.4509C27.8504 38.727 27.6265 38.9509 27.3504 38.9509H25.369C25.0928 38.9509 24.869 38.727 24.869 38.4509V37.4538C24.869 37.1777 25.0928 36.9538 25.369 36.9538H27.3504C27.6265 36.9538 27.8504 37.1777 27.8504 37.4538V38.4509ZM41.7635 38.4509C41.7635 38.727 41.5396 38.9509 41.2635 38.9509H30.3377C30.0616 38.9509 29.8377 38.727 29.8377 38.4509V37.4538C29.8377 37.1777 30.0616 36.9538 30.3377 36.9538H41.2635C41.5396 36.9538 41.7635 37.1777 41.7635 37.4538V38.4509ZM47.7264 38.4509C47.7264 38.727 47.5025 38.9509 47.2264 38.9509H44.2508C43.9747 38.9509 43.7508 38.727 43.7508 38.4509V37.4538C43.7508 37.1777 43.9747 36.9538 44.2508 36.9538H47.2264C47.5025 36.9538 47.7264 37.1777 47.7264 37.4538V38.4509ZM32.8192 33.4587C32.8192 33.7348 32.5953 33.9587 32.3192 33.9587H25.369C25.0928 33.9587 24.869 33.7348 24.869 33.4587V32.4616C24.869 32.1855 25.0928 31.9616 25.369 31.9616H32.3192C32.5953 31.9616 32.8192 32.1855 32.8192 32.4616V33.4587ZM39.7762 33.4587C39.7762 33.7348 39.5523 33.9587 39.2762 33.9587H35.3065C35.0303 33.9587 34.8065 33.7348 34.8065 33.4587V32.4616C34.8065 32.1855 35.0303 31.9616 35.3065 31.9616H39.2762C39.5523 31.9616 39.7762 32.1855 39.7762 32.4616V33.4587ZM47.7264 33.4587C47.7264 33.7348 47.5025 33.9587 47.2264 33.9587H42.2635C41.9873 33.9587 41.7635 33.7348 41.7635 33.4587V32.4616C41.7635 32.1855 41.9873 31.9616 42.2635 31.9616H47.2264C47.5025 31.9616 47.7264 32.1855 47.7264 32.4616V33.4587Z"
        fill="#C2A085"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12634"
        x="-4.10001"
        y="0"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12634"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12634"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
